<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card>
          <v-card-title>
            {{ this.title }}
          </v-card-title>
          <v-card-text>Sabrina Speich (Chief Scientist, R/V L'Atalante)
          </v-card-text>
          <v-container fluid>
            <v-row>
              <v-container fluid>
                <video
                  src="https://observations.ipsl.fr/aeris/eurec4a-data/PRODUCTS/OUTREACH/Sabrina_Speich_EUREC4A.m4v"
                  controls
                  autoplay
                  width="800px"
                >
                  Your browser does not support the video tag.
                </video>
                <br /><br />
                <a href="https://observations.ipsl.fr/aeris/eurec4a-data/PRODUCTS/OUTREACH/Sabrina_Speich_EUREC4A.m4v" download>Download presentation (high quality)</a><br />
                <a href="https://observations.ipsl.fr/aeris/eurec4a-data/PRODUCTS/OUTREACH/Sabrina_Speich_EUREC4A_normal.m4v" download>Download presentation (normal quality)</a>
              </v-container>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    dense: false,
    fixedHeader: false,
    height: 300,
    title: ""
  }),
  mounted: function() {
    this.title =
      "Elucidating the role of Clouds and ocean-atmosphere interactions in circulations and climate";
  }
};
</script>
